import { useNavigate, Link } from 'react-router-dom';
import styled from "styled-components";
import { useSnackbar } from "notistack";
import {
    Typography,
} from "@mui/material";
import copy from 'copy-to-clipboard';

import { IconCopy, IconDownload } from '@tabler/icons-react';

import { TitleContainer, StyledTypography } from '../../../Styles/CustomViews/Pages/customTitleStyles';

import { LicenseKeyTitleInterface } from '../../../Models/Common/CustomViewsInterfaces';

import { SuccessMessage } from '../../../Constants/Messages';

import CustomIconButton from '../../Elements/CustomIconButton';
import NewTab from '../NewTab/NewTab';

const LicenseKeyContainer: any = styled.div<{ $isClickable?: boolean; }>`
    .MuiButtonBase-root.MuiIconButton-root.MuiIconButton-sizeMedium {
        width: 30px;
        height: 30px;
        margin: 0px 0px 0px 5px;

        &:last-of-type {
            margin: 0px !important;
        }
    }

    .MuiTypography-root.MuiTypography-caption.MuiTypography-gutterBottom {
        cursor: ${(props) => (props.$isClickable ? 'pointer' : 'default')};
    }
`;

const LicenseKeyTitle = (props: LicenseKeyTitleInterface) => {
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();

    return <LicenseKeyContainer $isClickable={props?.linkUrl != null && props?.linkUrl != ""}>
        {(props?.linkUrl && props?.linkUrl != null && props?.linkUrl != "") ? <NewTab 
            linkTitle={props?.licenseKey ?? "--"}
            linkUrl={props.linkUrl} /> : <Typography variant="caption" color={props?.color ?? "info"} gutterBottom >{props.licenseKey}</Typography>
        }
        
        <CustomIconButton toolTipName='Copy'
            icon={<IconCopy color="#0288d1" />}
            onClick={(e: any) => {
                e.preventDefault()

                copy(props?.licenseKey ?? "");
                 // navigator.clipboard.writeText(props?.licenseKey ?? "");

                enqueueSnackbar(SuccessMessage.LICENSE_KEY_COPIED, { variant: 'success' });
            }} />
        <CustomIconButton toolTipName='Download'
            icon={<IconDownload color="#0288d1" />}
            onClick={(e: any) => {
                e.preventDefault();

                const blob = new Blob([props?.licenseKey ?? ""], { type: 'text/plain' });
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = 'license-key.txt';
                a.click();
                URL.revokeObjectURL(url);

                enqueueSnackbar(SuccessMessage.LICENSE_KEY_DOWNLOADED, { variant: 'success' });
            }} />
    </LicenseKeyContainer>
}

export default LicenseKeyTitle;